import React from "react";
import { Entry } from "../../GratefulDB";
import { useFavorites } from "./useFavorites";

const EntryFavoriteToggleIcon: React.FC<{
  entry: Entry;
}> = (props): JSX.Element => {
  const favorites = useFavorites();

  return (
    <i
      className={`ui link heart small ${
        !favorites.contains(props.entry.identifier) ? "outline" : ""
      } icon`}
      onClick={() => favorites.toggle(props.entry.identifier)}
    />
  );
};

export default EntryFavoriteToggleIcon;
